/* index: page top */
window.addEventListener("DOMContentLoaded", (event) => {
	const topBtn = document.getElementById("totop");
	topBtn.style.display = "none";
	window.addEventListener("scroll", function () {
		if (window.pageYOffset > 100) {
			topBtn.style.display = "block";
		} else {
			topBtn.style.display = "none";
		}
	});
	topBtn.addEventListener("click", function (event) {
		event.preventDefault();
		window.scrollTo({ top: 0, behavior: "smooth" });
	});
});

/* index: mobile navigation menu */

window.addEventListener("DOMContentLoaded", (event) => {
	const mobileHead = document.getElementById("nav_btn");
	const navLinks = document.querySelectorAll("#global_nav_sp a");
	const body = document.body;
	const navOverlay = document.getElementById("nav_overlay");

	function toggleHeader() {
		body.classList.toggle("--activeNav");
		if (body.classList.contains("--activeNav")) {
			body.style.pointerEvents = "none";
			body.style.overflow = "hidden";
		} else {
			body.style.pointerEvents = "";
			body.style.overflow = "";
		}
	}

	function hideHeader() {
		body.classList.remove("--activeNav");
		body.style.pointerEvents = "";
		body.style.overflow = "";
	}

	mobileHead.addEventListener("click", toggleHeader);
	navLinks.forEach((link) => link.addEventListener("click", hideHeader));
	navOverlay.addEventListener("click", hideHeader);
});

const setVh = () => {
	const vh = window.innerHeight * 0.01;
	const vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
	document.documentElement.style.setProperty("--vw", `${vw}px`);
};

window.addEventListener("load", setVh);
window.addEventListener("resize", setVh);

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: はみ出した要素を確認する */
document.querySelectorAll("*").forEach((el) => (el.clientWidth > document.body.clientWidth ? console.log(el) : null));

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: コンソール削除 */
console.clear();
